import type { PropsWithChildren } from 'react'
import { headerShellStyle } from './header.css'

export function HeaderShell(props: PropsWithChildren) {
  return <div className={headerShellStyle}>{props.children}</div>
}
